var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReceiveTable',{attrs:{"opt-type":20}})
}
var staticRenderFns = []

export { render, staticRenderFns }